import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { HanCoinDepositProvider } from "@-/dev.improve.haniverse.components.ui.han-coin-deposit";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { readHanWallet } from "@-/dev.improve.haniverse.lib.han-currency";
import { NavContext } from "@-/dev.improve.haniverse.routes.nav._context";
import { type PropsWithChildren, useCallback } from "react";

/** Han coin deposits for the app shell: clinks follow the app's mute, the counters the wallet. */
export function NavHanCoinDepositProvider({ children }: PropsWithChildren) {
  const [isMuted] = useContextSelectors(NavContext, (c) => c.isMutedOverride);
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);
  const readBalances = useCallback(async () => {
    const { han, hanMiles } = await readHanWallet(actorDb(import.meta.location));
    return { han, hanMiles };
  }, [actorDb]);
  return (
    <HanCoinDepositProvider isMuted={isMuted} readBalances={readBalances}>
      {children}
    </HanCoinDepositProvider>
  );
}
